export { default } from './ObservationTable.component';
export * from './ObservationTable.component';
